import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Typography
} from '@mui/material';

function CustomerRegistrationDialog({ open, onClose, businessId, onRegistered }) {
    const [form, setForm] = useState({
        name: '',
        familya: '',
        username: '',
        phoneNumber: '',
        rawPhoneNumber: '', // Backend uchun toza raqam
        birthday: '',
        sex: 'true',
    });
    const [registered, setRegistered] = useState(false);
    const [botUrl, setBotUrl] = useState(null);
    const [loadingBotUrl, setLoadingBotUrl] = useState(false);

    // 🔗 Bot URL ni backenddan olamiz
    useEffect(() => {
        if (!businessId) return;
        const apiUrl = process.env.REACT_APP_API_URL || 'https://dexel.store:9093';
        const load = async () => {
            try {
                setLoadingBotUrl(true);
                const res = await fetch(`${apiUrl}/api/admin/business-bot/${businessId}/info`);
                const data = await res.json();
                if (data && data.botUrl) setBotUrl(data.botUrl);
                else setBotUrl(null);
            } catch {
                setBotUrl(null);
            } finally {
                setLoadingBotUrl(false);
            }
        };
        load();
    }, [businessId]);

    // Telefon raqamini formatlash
    const formatPhoneNumber = (value) => {
        const digits = value.replace(/[^\d]/g, '');
        let formatted = '';
        if (digits.startsWith('998') && digits.length > 3) {
            const code = digits.slice(0, 3);
            const part1 = digits.slice(3, 5);
            const part2 = digits.slice(5, 8);
            const part3 = digits.slice(8, 10);
            const part4 = digits.slice(10, 12);

            formatted = `+${code}`;
            if (part1) formatted += ` ${part1}`;
            if (part2) formatted += ` ${part2}`;
            if (part3) formatted += ` ${part3}`;
            if (part4) formatted += ` ${part4}`;
        } else {
            formatted = digits;
        }
        return formatted;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phoneNumber') {
            const rawDigits = value.replace(/[^\d]/g, '');
            setForm(prev => ({
                ...prev,
                phoneNumber: formatPhoneNumber(value),
                rawPhoneNumber: rawDigits.length === 12 ? `+${rawDigits}` : '' // 998XXXXXXXXX (12 raqam) bo'lsa + qo'shamiz
            }));
        } else {
            setForm((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async () => {
        if (!form.name || !form.rawPhoneNumber) {
            alert('Ism va telefon raqami kiritilishi shart');
            return;
        }
        if (!form.rawPhoneNumber.startsWith('+998') || form.rawPhoneNumber.length !== 13) {
            alert('Telefon raqami +998 bilan boshlanishi va 9 ta raqamdan iborat bo‘lishi kerak');
            return;
        }

        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'https://dexel.store:9093';
            const body = {
                name: form.name,
                familya: form.familya,
                username: form.username,
                phoneNumber: form.rawPhoneNumber,
                birthday: form.birthday,
                sex: form.sex === 'true',
                businessId,
            };

            const res = await fetch(`${apiUrl}/api/public/register`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });

            if (!res.ok) {
                const errData = await res.json();
                throw new Error(errData.message || 'Xatolik yuz berdi');
            }

            const data = await res.json();
            if (data.success) {
                setRegistered(true);
                onRegistered && onRegistered(data.customer);
                // xohlasangiz shu yerdanoq avtomatik ochib yuborishingiz ham mumkin:
                // if (botUrl) window.open(botUrl, '_blank');
            } else {
                alert(data.message || 'Ro‘yxatdan o‘tishda xatolik');
            }
        } catch (e) {
            alert(`Xatolik: ${e.message}`);
        }
    };

    const openBot = () => {
        if (botUrl) {
            window.open(botUrl, "_blank");
        } else {
            alert('Bot manzili topilmadi. Iltimos biznes administratoriga murojaat qiling.');
        }
    };

    return (
        <Dialog open={open} maxWidth="xs" fullWidth disableEscapeKeyDown>
            {!registered ? (
                <>
                    <DialogTitle>Mijozni ro‘yxatdan o‘tkazish</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Ism"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            required
                        />
                        <TextField
                            label="Familya"
                            name="familya"
                            value={form.familya}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Username"
                            name="username"
                            value={form.username}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Telefon raqami"
                            name="phoneNumber"
                            value={form.phoneNumber}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            required
                            inputProps={{ maxLength: 17 }}
                        />
                        <Typography variant="caption" color="textSecondary" sx={{ mt: 1, mb: 2, display: 'block' }}>
                            Telegramda ro‘yxatdan o‘tgan raqamingizni yozing va to‘g‘ri yozing.
                        </Typography>
                        <TextField
                            label="Tug‘ilgan sana"
                            name="birthday"
                            type="date"
                            value={form.birthday}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                        />
                        <FormControl component="fieldset" margin="normal">
                            <FormLabel component="legend">Jinsi</FormLabel>
                            <RadioGroup row name="sex" value={form.sex} onChange={handleChange}>
                                <FormControlLabel value="true" control={<Radio />} label="Erkak" />
                                <FormControlLabel value="false" control={<Radio />} label="Ayol" />
                            </RadioGroup>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={onClose}>Bekor qilish</Button>
                        <Button variant="contained" onClick={handleSubmit}>
                            Ro‘yxatdan o‘tish
                        </Button>
                    </DialogActions>
                </>
            ) : (
                <>
                    <DialogTitle>Muvaffaqiyatli ro‘yxatdan o‘tildi</DialogTitle>
                    <DialogContent>
                        <Typography sx={{ mb: 2 }}>
                            Endi botga o‘ting va <b>/start</b> bosib, <b>“Raqamni ulashish 📞”</b> tugmasi orqali telefon raqamingizni jo‘nating.
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {loadingBotUrl ? 'Bot manzili yuklanmoqda...' : (botUrl || 'Bot manzili topilmadi')}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            onClick={openBot}
                            disabled={loadingBotUrl || !botUrl}
                        >
                            BOT orqali haridlarni davom ettirish
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}

export default CustomerRegistrationDialog;
